import Vue from 'vue'
import App from './App.vue'
import {router} from './router'
import store from './store'

Vue.config.productionTip = false

/* import request api */
import request from '@/api/console.js'
Vue.prototype.$api = request

/* import element ui */
import {
  Table,
  TableColumn,
  Button,
  Image,
  Input,
  Select,
  Option,
  Radio,
  Checkbox,
  DatePicker,
  CheckboxGroup,
  CheckboxButton,
  RadioGroup,
  Tag,
  Pagination,
  Tree,
  Form,
  FormItem,
  Upload,
  Dialog,
  Loading,
  Message,
  Switch,
  Avatar,
  Tooltip,
  MessageBox,
} from 'element-ui'

Vue.use(Table).use(TableColumn)
Vue.use(Button)
Vue.use(Switch)
Vue.use(Avatar)
Vue.use(Tooltip)
Vue.use(Image)
Vue.use(Input)
Vue.use(Select).use(Option).use(Radio).use(RadioGroup)
Vue.use(Tag)
Vue.use(Pagination)
Vue.use(Tree)
Vue.use(Dialog)
Vue.use(Upload)
Vue.use(Checkbox).use(CheckboxGroup)
Vue.use(Checkbox).use(CheckboxButton)
Vue.use(DatePicker)
Vue.use(Form).use(FormItem)
Vue.use(Loading)

// 全局挂载
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;

// 消息提示的二次封装
const message = (msg, type, show = true) => {
  Message({
    showClose: show,
    message: msg,
    type,
  })
}

// 全局挂载Message
Vue.prototype.$message = message
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

/* import editor */
